import React, { useEffect, useRef } from 'react';
import { useHistory } from 'react-router-dom';
import clsx from 'clsx';
import { Dialog, DialogContent, Grid } from '@mui/material';
import { Button, Form, MenuItem, SelectField, Stack, Box } from "@curves/ui-base";
import { PasswordAgeWarningTextBox } from '@root/scripts/login/component/';
import GradientColorHeader from '@icoach/components/dialog/GradientColorHeader';
import { PasswordToggle } from '@icoach/components/';
import { ReadTextField } from '@icoach/components';
import useGetEmployeeOptionState from '@util/hook/useGetEmployeeOptionState';
import { generateSecurity } from '@util/apiCryto';
import useAuthUserApi from '@apis/useAuthUserApi';
import useAuthApi from '@apis/useAuthApi';
import { CLUB_LOGIN_ROUTER, EMPLOYEE_LOGIN_ROUTER } from '@icoach/router/routerPath';
import { localUser, isEmpty } from '@util/utils';
import useMessageDialog from '@util/hook/useMessageDialog';

const EmployeeLoginDialog = (props) => {
    const { employeeOption } = useGetEmployeeOptionState();
    const { postLoginEmployeeApi, postEmployeeNoChangeAuthPwdApi } = useAuthUserApi();
    const { getLogoutApi } = useAuthApi();
    const setMessageDialog = useMessageDialog();
    const history = useHistory();
    const user = localUser.get();
    const userRef = useRef(null);
    const passwordRef = useRef(null);

    const getParams = () => {
        const id = userRef.current.getResult();
        const paswd = passwordRef.current.getResult();
        const { hmacSecurity, hmacKey } = generateSecurity(paswd);
        return {
            employeeID: id,
            password: hmacSecurity,
            hmacKey,
        };
    };

    // 修改密碼視窗
    const notificationMessage = (token) => {
        setMessageDialog({
            open: true,
            dialogPaperProps: { className: 'wx-65rem' },
            title: '通知',
            buttonText: '此次不變更',
            dialogActionsProps: {
                className: 'flex-y-flex-center',
            },
            buttonVariant: 'text',
            onClose: () => {
                // 直接進入首頁
                history.push(CLUB_LOGIN_ROUTER.BASE);
            },
            onAsyncConfirm: (_e, onClose) => {
                postRecordApi(token, onClose);
            },
            MsgComp: ({ onClose }) => {
                return (
                    <React.Fragment>
                        <PasswordAgeWarningTextBox />
                        <Stack justifyContent="center">
                            <Button
                                onClick={() => {
                                    onClose();
                                    jumpToModifyPasswordAction(token);
                                }}
                                variant="contained"
                            >
                                前往修改密碼
                            </Button>
                        </Stack>
                    </React.Fragment>
                );
            },
        });
    };

    const jumpToModifyPasswordAction = async (token) => {
        history.push(EMPLOYEE_LOGIN_ROUTER.GET_CLUB_RESET_PATH(token));
    };

    const handleSubmit = () => {
        const params = getParams();
        postEmployeeLoginApi(params);
    };

    const handleBackToClub = () => {
        getLogoutClubApi();
    };

    const getLogoutClubApi = async () => {
        await getLogoutApi();
    };

    const postRecordApi = async (token, onClose) => {
        const resp = await postEmployeeNoChangeAuthPwdApi(token);
        if (resp) {
            // 直接進入首頁
            history.push(CLUB_LOGIN_ROUTER.BASE);
            onClose();
        }
    };

    const postEmployeeLoginApi = async (params) => {
        const resp = await postLoginEmployeeApi(params);
        if (resp) {
            localUser.setEmployeeData(resp);
            if (resp.isPasswordResetRequired) {
                history.push(EMPLOYEE_LOGIN_ROUTER.GET_COACH_RESET_PATH(resp.token)); // 帶token過去 透過這個來判斷教練
            } else if (resp.isPasswordResetNotify) {
                notificationMessage(resp.token);
            } else {
                // 切換到首頁
                history.push(CLUB_LOGIN_ROUTER.BASE);
            }
        }
    };

    const doInitialization = () => {
        const employee = localUser.get('employee');
        if (!isEmpty(employee)) {
            history.push(CLUB_LOGIN_ROUTER.BASE);
        }
    };

    useEffect(
        () => {
            doInitialization();
        },
        // eslint-disable-next-line
        []
    );

    return (
        <Dialog
            className={clsx('simple-content', 'dialog', 'user-login-dialog')}
            PaperProps={{ className: 'wx-70rem', component: Form }}
            BackdropProps={{
                style: {
                    backgroundColor: '#797a7c',
                },
            }}
            onSubmit={handleSubmit}
            open={true}
            fullWidth
        >
            <GradientColorHeader>教練登入</GradientColorHeader>
            <DialogContent>
                <Box className={'user-login-dialog__wrapper'}>
                    <Grid container spacing={2}>
                        <Grid item xs={12}>
                            <ReadTextField label={'店舖名：'}>{user.displayName}</ReadTextField>
                        </Grid>
                        <Grid item xs={12}>
                            <SelectField label="當前教練" ref={userRef} fullWidth required>
                                {Array.isArray(employeeOption) &&
                                    employeeOption.map(({ value, text, disabled }) => (
                                        <MenuItem key={value} value={value} disabled={disabled}>
                                            {text}
                                        </MenuItem>
                                    ))}
                            </SelectField>
                        </Grid>
                        <Grid item xs={12}>
                            <PasswordToggle ref={passwordRef} />
                        </Grid>
                        <Grid item xs={12}>
                            <Stack className={'mt-2'} justifyContent={'center'} spacing={3}>
                                <Button variant="contained" type="submit">
                                    確定
                                </Button>
                                <Button variant="outlined" onClick={handleBackToClub}>
                                    離開店舖
                                </Button>
                            </Stack>
                        </Grid>
                    </Grid>
                </Box>
            </DialogContent>
        </Dialog>
    );
};

export default EmployeeLoginDialog;
